<h1 style="text-align: center;">Booth Agent Discount For Fermented Products</h1>
<table class="table table-dark">
  <thead>
    <tr>
      <th scope="col"></th>
      <th *ngFor="let product of discount_products" scope="col">{{product['short_name']}}</th>
    </tr>
    <tr>
      <th scope="col">MRP</th>
      <th *ngFor="let product of discount_products" scope="col">{{product['mrp'] | currency:'INR'}}</th>
    </tr>
    <tr>
        <th scope="col">GST</th>
        <th *ngFor="let product of discount_products" scope="col">{{product['gst']}} %</th>
      </tr>
  </thead>
  <tbody>
    <tr *ngFor="let business_type of business_types">
      <th scope="row">{{business_type['name']}}</th>
      <td *ngFor="let product of discount_products" style="cursor: pointer;"
        (click)="openDialog(business_type['id'], business_type['name'], product['id'], product['short_name'], discountPrice(business_type['id'], product['id']))">
        {{discountPrice(business_type['id'], product['id'])}}</td>
    </tr>
  </tbody>
</table>
